import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/stats';
export function StatsBar() {
  return <section className="bg-sand px-4 py-12 md:py-14" data-id="element-182" data-mp="1tbjghngupucr">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 text-center md:grid-cols-4 md:gap-8" data-id="element-183" data-mp="1t8nf1p5sonjk">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-sand-deep' : ''}`} data-id="element-184" data-mp="1jbiu1snoqy4c" data-mpi={index}>
            <span className="font-heading text-3xl font-bold text-petrol md:text-4xl" data-id="element-185" data-mp="19m90s9h3v9en">{value}</span>
            <span className="mt-1.5 font-note text-[10px] font-semibold uppercase tracking-[0.12em] text-muted md:text-xs" data-id="element-186" data-mp="15k4bfmxowyxt">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}